import { FC } from "react";
import { ratingColor } from "utils/general"
import styles from "./index.module.scss"




interface IProps {
    rate: number
}

const Rate: FC<IProps> = ({ rate }) => {


    return (
        <span
            className={styles.rate + " text-white px-xs"}
            style={{ backgroundColor: ratingColor(rate) }}
        >
            {rate}
        </span>
    )
}

export default Rate